import type { PropsWithChildren } from 'react';

import { cx } from 'cva';
import {
  OverlayArrow,
  Tooltip as RACTooltip,
  type TooltipProps as RACTooltipProps,
} from 'react-aria-components/Tooltip';

import styles from './tooltip.module.css';

export type TooltipProps = RACTooltipProps & PropsWithChildren;

/**
 * Tooltip component that can be used to display content in a floating container.
 *
 * Use `Tooltip` to show additional content or actions related to a specific element.
 *
 * See https://react-spectrum.adobe.com/react-aria/Tooltip.html for the underlying
 * implementation.
 *
 * ```tsx
 * <Tooltip>
 *  <div>Tooltip content</div>
 * </Tooltip>
 * ```
 */
export const Tooltip = ({ children, className, ...props }: TooltipProps) => {
  const classes = cx(styles.tooltip, className);
  return (
    <RACTooltip className={classes} offset={8} {...props}>
      <OverlayArrow className={styles.overlay_arrow}>
        <svg width={8} height={8} viewBox="0 0 8 8">
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {children}
    </RACTooltip>
  );
};
